import React, {Component} from 'react';
import axios from 'axios';

let accessKey = "2b224aa659b1c0f8436ed601f219bf54093804345602dd0413f50793e98e3638";
let url='https://api.unsplash.com/photos?client_id='+accessKey;

class Pictures extends Component {
    state = {
        images: [],
        selectedImage: null,
    }


    componentDidMount() {
        axios.get(`https://picsum.photos/v2/list`).then((response) => {
            const data = response.data.slice(0,10);
            this.setState({ images: data });
            this.selectHandler(data[0]);
        })

    }

    selectHandler = (image) => {
        this.setState({ selectedImage: image.id });
        return this.props.selected(image);
    }





    render() {
        return (
            <div>
                <ul className="image_list">
                    {this.state.images.map(images => <li className="image_row" key={images.id}  >
                        <img style={{ border : this.state.selectedImage===images.id ? '3px solid #50E3C2' : 'none' }}
                            src={images.download_url}  onClick={() => this.selectHandler(images)

                        }/>
                    </li>)}
                </ul>

            </div>
        );
    }
}

export default Pictures;

